<ng-container *ngIf="isModal">
		<ng-container *ngTemplateOutlet="popupContentTemplate"></ng-container>
</ng-container>

<ng-container *ngIf="!isModal">
	<div class="kendo-popup-anchor" #anchor [style.top]="Top" [style.left]="Left"></div>
	<div dir="ltr">
		<kendo-popup [anchor]="anchor"
					 *ngIf="show!==false || keepContentsOnDOM"
					 [popupClass]="'kendo-popup-contents'" [collision]="{horizontal:'fit',vertical:'fit'}"
					 [popupAlign]='{ horizontal: "left", vertical: "top" }' >
			<ng-container *ngTemplateOutlet="popupContentTemplate"></ng-container>
		</kendo-popup>
	</div>
</ng-container>

<ng-template #popupContentTemplate>
	<div class="popup-wrapper" [dir]="rtlStr" [class.strong-visibility]="strongVisibility" [class.non-modal]="!isModal" [style.width]="Width" [style.height]="Height"
		 [style.min-width]="minWidth ? minWidth: false" [style.min-height]="minHeight ? minHeight: false"
		 [ngStyle]="{'top':isModal?Top:undefined,'left':isModal?Left:undefined}" (window:touchmove)="overrideTouchMove($event)">

		<audio #audio *ngIf="isModal" controls src="./assets/sounds/pingSound.mpeg"></audio>

		<div class="spinner-wrapper" *ngIf="spinner">
			<div class="spinner"></div>
		</div>

		<ng-container *ngIf="resizable">
			<span class="resize top-left" (cpDeltaDrag)="topLeftResize($event)" [deltaDragStopOnLeave]="true"></span>
			<span class="resize top-right" (cpDeltaDrag)="topRightResize($event)" [deltaDragStopOnLeave]="true"></span>
		</ng-container>

		<div class="popup-header"
			#popupHeader
			[class.draggable]="draggable"
			[deltaOverrideElementRef]="popupHeader"
			(cpDeltaDragEnd)="dragEnded()" (cpDeltaDrag)="headerDeltaDrag($event)" [deltaDragDisable]="!draggable">
			<div *ngIf="label" class="label" title="{{label | cpTitleTranslate: {a0: labelParam} }}"><h1 (click)="onLabelClick($event)">{{label | cpTitleTranslate: {a0: labelParam} }}</h1></div>
			<div *ngIf="!label && labelPlain" class="label" title="{{ labelPlain }}"><h1 (click)="onLabelClick($event)">{{ labelPlain }}</h1></div>
			<div class="fill"></div>
			<div class="close" (click)="onClose()">
				<i class="cp-sh-icon-close_btn"></i>
			</div>
		</div>

		<div class="popup-content" [cpTouchDrag] #content
			 [ngClass]="{'auto-height-re-calc': autoHeight && autoHeightAutoReCalc,
						 'auto-height': autoHeight,
						 'content-padding': contentPadding}">
			<ng-content></ng-content>
		</div>

		<ng-container *ngIf="resizable">
			<span class="resize bottom-left" (cpDeltaDrag)="bottomLeftResize($event)"></span>
			<span class="resize bottom-right" (cpDeltaDrag)="bottomRightResize($event)"></span>
		</ng-container>
	</div>
</ng-template>

